import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "vite/modulepreload-polyfill";

// import global styles
import "@narmi/design_system/dist/style.css";
import "cerulean/styles.scss";

const rootEl = document.getElementById("root");

if (rootEl) {
  const root = ReactDOM.createRoot(rootEl);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
